import InPlayOverviewComponent from './in_play_overview_component';

export default InPlayOverviewComponent;
